import {CopilotAnimation, CopilotAnimationType} from '@github-ui/copilot-animation'
import {Heading, Stack} from '@primer/react'

export interface CopilotStartHeaderProps {
  animationType?: CopilotAnimationType
  loopAnimation?: boolean
}

export default function CopilotStartHeader({animationType = 'static', loopAnimation = false}: CopilotStartHeaderProps) {
  return (
    <Stack direction="vertical" align="center" gap="condensed" className="pb-2">
      <CopilotAnimation
        className="flex-shrink-0"
        animationType={animationType}
        loopAnimation={loopAnimation}
        size={36}
      />
      <Heading as="h2" className="h2">
        Start building with Copilot
      </Heading>
    </Stack>
  )
}
